import React, { useState, useEffect } from 'react';
import { notesAPI } from '../services/api';
import LinkifyText from './LinkifyText';
import './NotesTab.css';

const NotesTab = ({ houseId }) => {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingNote, setEditingNote] = useState(null);
  const [formContent, setFormContent] = useState('');

  useEffect(() => {
    if (houseId) {
      loadNotes();
    }
  }, [houseId]);

  const loadNotes = async () => {
    try {
      const response = await notesAPI.getAll(houseId);
      setNotes(response.data);
    } catch (error) {
      console.error('Error loading notes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formContent.trim()) return;

    try {
      if (editingNote) {
        await notesAPI.update(editingNote.id, { content: formContent });
      } else {
        await notesAPI.create({ house_id: houseId, content: formContent });
      }
      setFormContent('');
      setShowForm(false);
      setEditingNote(null);
      loadNotes();
    } catch (error) {
      console.error('Error saving note:', error);
      alert('Failed to save note');
    }
  };

  const handleEdit = (note) => {
    setEditingNote(note);
    setFormContent(note.content);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this note?')) {
      try {
        await notesAPI.delete(id);
        loadNotes();
      } catch (error) {
        console.error('Error deleting note:', error);
        alert('Failed to delete note');
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingNote(null);
    setFormContent('');
  };

  if (loading) {
    return <div className="notes-loading">Loading notes...</div>;
  }

  if (!houseId) {
    return <div className="notes-message">Please select a house</div>;
  }

  return (
    <div className="notes-tab">
      <div className="notes-header">
        <h2>Notes</h2>
        <button className="btn-add" onClick={() => setShowForm(true)}>
          + Add Note
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="note-form">
          <textarea
            value={formContent}
            onChange={(e) => setFormContent(e.target.value)}
            placeholder="Write your note here..."
            rows="6"
            required
          />
          <div className="note-form-actions">
            <button type="button" className="btn-cancel" onClick={handleCancel}>
              Cancel
            </button>
            <button type="submit" className="btn-submit">
              {editingNote ? 'Update' : 'Save'}
            </button>
          </div>
        </form>
      )}

      {notes.length === 0 ? (
        <div className="notes-empty">No notes yet. Add your first note!</div>
      ) : (
        <div className="notes-list">
          {notes.map((note) => (
            <div key={note.id} className="note-card">
              <div className="note-content">
                <LinkifyText text={note.content} className="note-content-text" />
              </div>
              <div className="note-footer">
                <span className="note-date">
                  {new Date(note.created_at).toLocaleString()}
                </span>
                <div className="note-actions">
                  <button className="btn-edit" onClick={() => handleEdit(note)}>
                    Edit
                  </button>
                  <button className="btn-delete" onClick={() => handleDelete(note.id)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                    </svg>
                    <span>Delete</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotesTab;

